import { IAmenities } from '@llws/lift-entity-interfaces';
import { adminRequest } from '@/shared/request-configs/admin-request';
import vm from '@/main';
import { translationFormatter } from '@/shared/helpers/translation-formatter';
import { IFilterPayloadV2 } from '@/shared';
import { getTranslationsByClientIdAndModel } from './translations';

/**
 * Fetches Custom and Default Amenities <br>
 * API Endpoint - `/property-api/amenities/all` via {@link adminRequest.get}
 * @param {boolean} [includeTranslations] - optional param to include translations in the response
 */
export const getCustomAndDefaultAmenities = async (payload?: IFilterPayloadV2) => {
  const result = await adminRequest.get(`/property-api/amenities/all${(payload?.additional?.fetchParentClientAmenities ? '?fetchParentClientAmenities=true' : '')}`);

  if (payload?.additional?.includeTranslations) {
    const app = vm();

    if (app && app?.$rsGlobals.$siteSourceClientLanguages?.length > 0) {
      const translations = await getTranslationsByClientIdAndModel(app.$rsGlobals.$currentClient.id!, 'amenities');
      result.data = translationFormatter(
        result.data,
        translations,
        app?.$rsGlobals.$siteSourceClientLanguages,
        {
          clientId: app.$rsGlobals.$currentClient.id!,
          model: 'amenities',
          keys: ['name'],
        },
      );
    }
  }

  return result;
};

/**
 * Creates Custom Amenity <br>
 * API Endpoint - `/client-api/clients/${clientId}/amenities` via {@link adminRequest.post}
 * @param {number} clientId - Custom Amenity will be under the specified clientId
 * @param {IAmenities[]} amenity - Array of Amenities to Save
 */
export const createCustomAmenity = (
  clientId: number,
  amenity: IAmenities[],
) => adminRequest.post(`/client-api/clients/${clientId}/amenities`, amenity);

/**
 * Removes Custom Amenity <br>
 * API Endpoint - `/client-api/clients/${clientId}/amenities` via {@link adminRequest.delete}
 * @param {number} clientId - clientId of the specified amenity
 * @param {number} amenityId - id of amenity to remove
 */
export const deleteCustomAmenity = (
  clientId: number,
  amenityId: number,
) => adminRequest.delete(`/client-api/clients/${clientId}/amenities`, [amenityId]);

export default {
  getCustomAndDefaultAmenities,
  createCustomAmenity,
  deleteCustomAmenity,
};
